import styles from './Table.module.css';

/**
 * Класс числовой ячейки: табличные цифры и выравнивание по правому краю
 * (DESIGN_SYSTEM §5.6). Живёт отдельно от компонента, чтобы `Table.tsx`
 * экспортировал только компоненты — иначе ломается fast refresh.
 */
export const tableNumericClass = styles.numeric ?? '';
